import { Checkbox, Radio, type Column } from '@library';
import { useStoryblokContext } from '../../StoryblokFormContext';

interface SelectionColumnParams {
    selectionType: 'multi' | 'single' | undefined;
    value: string[] | string;
    onChange: (value: string[] | string) => void;
    namePrefix?: string;
}

export function useSelectionColumn<T extends { id: string }>({
    selectionType,
    value,
    onChange,
    namePrefix = '',
}: SelectionColumnParams): Column<T> | null {
    const { readonly } = useStoryblokContext();
    if (selectionType === 'multi') {
        return {
            key: 'checkbox',
            header: '',
            width: '21px',
            render: item => {
                const currentValue = (value || []) as string[];
                return (
                    <Checkbox
                        disabled={readonly}
                        checked={
                            !!currentValue.find(
                                itemValue => itemValue === item.id
                            )
                        }
                        onChange={checked => {
                            if (checked) {
                                onChange([...currentValue, item.id]);
                            } else {
                                onChange(
                                    currentValue.filter(
                                        itemValue => itemValue !== item.id
                                    )
                                );
                            }
                        }}
                    />
                );
            },
        };
    }

    if (selectionType === 'single') {
        return {
            key: 'checkbox',
            header: '',
            width: '21px',
            render: item => {
                const currentValue = value as string;
                return (
                    <Radio
                        disabled={readonly}
                        checked={currentValue === item.id}
                        value={namePrefix + 'radio'}
                        onChange={() => {
                            onChange(item.id);
                        }}
                    />
                );
            },
        };
    }

    return null;
}
